<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6-tablet is-5-desktop is-4-widescreen">
            <form
              class="lm-forms"
            >
              <div class="level lm-level">
                <div class="level-item has-text-centered">
                  <figure class="image is-128x128">
                    <img :src="loadLogo" />
                  </figure>
                </div>
              </div>
              <div class="block">
                <b-field>
                  <b-field
                    class="lm-label"
                    :label="$t('CreateAccount.labelDefinePassword')"
                    :type="validateTypePassword"
                    :message="errorMessagePassword"
                  >
                    <b-input
                      class="lm-input"
                      v-model.trim="$v.password.$model"
                      type="password"
                      password-reveal
                    />
                  </b-field>
                </b-field>
                <b-field>
                  <b-field
                    class="lm-label"
                    :label="$t('CreateAccount.labelRetypePassword')"
                    :message="errorSamePassword"
                  >
                    <b-input
                      class="lm-input"
                      v-model.trim="$v.repeatPassword.$model"
                      type="password"
                      password-reveal
                      @keyup.native.enter="register"
                    />
                  </b-field>
                </b-field>
                <b-field>
                  <b-button
                    v-t="'Common.register'"
                    type="is-success"
                    class="lm-default-btn-green local-lm-xt-margin"
                    @click.prevent="register"
                  />
                </b-field>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { mixin } from '@/mixins'
import Logo from '@/assets/img/lm_logo.svg'

export default {
  name: 'CreateAccount',
  mixins: [
    mixin.notifications
  ],
  data () {
    return {
      password: '',
      repeatPassword: '',
      type: '',
      key: ''
    }
  },
  computed: {
    loadLogo () {
      return Logo
    },
    validateTypePassword () {
      return !this.$v.password.minLength
        ? 'is-danger'
        : null
    },
    errorSamePassword () {
      return (!this.$v.password.invalid && !this.$v.repeatPassword.sameAsPassword)
        ? this.$t('Errors.validSamePassword')
        : null
    },
    errorMessagePassword  () {
      return !this.$v.password.minLength
        ? this.$t('Errors.passwordLength')
        : null
    }
  },
  mounted () {
    this.key = this.$route.query.key
    this.type = this.$route.query.type || null
  },
  methods: {
    async register () {
      if (this.$v.$invalid) {
        this.wrong(this.$t('Errors.warningAllFieldsWithData'))
        return false
      }

      const params = {
        newPassword: this.password,
        type: this.type,
        key: this.key
      }

      const addPassword = await this.$store.dispatch('user/setPassword', params)
      if (!addPassword.level) return this.wrong(this.$t(addPassword.errorText))

      this.$store.dispatch('orders/flush')
      this.$store.dispatch('filters/flush')
      this.$store.dispatch('modal/flush')
      this.$store.dispatch('user/flush')
      this.$store.dispatch('modal/disable')

      this.sucess(this.$t('Common.success'))
      this.$router.push('Login')
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(8)
    },
    repeatPassword: {
      sameAsPassword: sameAs('password')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CreateAccount.vue